import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiper_next",
  "use": "icon-swiper_next-usage",
  "viewBox": "0 0 27 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 44\" id=\"icon-swiper_next\"><path d=\"M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol